import { useEffect, useState } from 'react';
import { useAuth } from 'react-oidc-context';
import { useAuthSync } from './useAuthSync';
import OrganizationService from '../services/organizationService';

export const useOrganizationFeatureTag = (tag) => {
  const auth = useAuth();
  const { user } = useAuthSync();
  const [isEnabled, setIsEnabled] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const loadOrganizationFeature = async () => {
      const token = auth.user?.access_token;
      const organizationId = user?.organizationId;

      if (!token || !organizationId || !tag) {
        if (isMounted) {
          setIsEnabled(false);
          setIsLoading(false);
        }
        return;
      }

      try {
        setIsLoading(true);
        const organization = await OrganizationService.getOrganizationById(organizationId, token);
        const tags = Array.isArray(organization?.tags) ? organization.tags : [];

        if (isMounted) {
          setIsEnabled(tags.includes(tag));
        }
      } catch (error) {
        if (isMounted) {
          setIsEnabled(false);
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    loadOrganizationFeature();

    return () => {
      isMounted = false;
    };
  }, [auth.user?.access_token, tag, user?.organizationId]);

  return {
    isEnabled,
    isLoading
  };
};

export default useOrganizationFeatureTag;